import { Link } from "react-router-dom";
import type { Work } from "@/types/work";
import { workTypeLabel } from "@/lib/workUtils";

interface WorkRowProps {
  work: Work;
}

export default function WorkRow({ work }: WorkRowProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-5 md:p-4"
    >
      <div className="relative h-40 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-48 md:w-32">
        <img
          src={work.poster}
          alt={`${work.title}海报`}
          title={`${work.title} 剧情介绍与演员信息`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {work.title}
          </h3>
          <span className="flex items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 text-xs font-bold text-accent-800">
            <i className="ri-star-fill text-[11px]" />
            {work.rating.toFixed(1)}
          </span>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="rounded bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
            {workTypeLabel(work.type)}
          </span>
          <span>{work.year}</span>
          <span>{work.region}</span>
          <span>{work.status}</span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:line-clamp-3 md:text-sm">
          {work.synopsis}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-star-line text-sm text-secondary-500" />
            主演：{work.cast.slice(0, 3).join(" / ")}
          </span>
        </div>
      </div>
    </Link>
  );
}